export function isTouchDevice() {
  // inspired by https://stackoverflow.com/a/4819886/437280
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  )
}
